import React, { useState, useEffect, Fragment, useRef } from "react";
import styles from './Breadcrumbs.less';
import { segments, join, normalize, basename } from '../../utils/path';
import { createURI } from '../../shared/utils/URI';
import { LocalFileSystemID } from "../../shared/types";
import { last } from 'ramda';
import { CommandID } from '../../commands';
import { command$ } from '../../observables/command';
import { Menu, ContextMenu } from '../../ui/components';
function createMenu(path, connId) {
    return [
        {
            id: CommandID.CopyPath,
            label: 'Copy Path',
            click: () => command$.next({ id: CommandID.CopyPath, uri: createURI(connId, path) })
        },
        {
            id: CommandID.CopyName,
            label: 'Copy Name',
            click: () => command$.next({ id: CommandID.CopyName, uri: createURI(connId, path) })
        },
        ...(connId == LocalFileSystemID
            ? [
                {
                    id: 'vscode',
                    label: "Open in VS Code",
                    click: () => { window.f5.open(createURI(LocalFileSystemID, path), 'code'); }
                },
                {
                    id: 'open',
                    label: 'Show in Finder',
                    click: () => { window.f5.open(createURI(LocalFileSystemID, path)); },
                },
            ]
            : [])
    ];
}
export default function Breadcrumbs({ icon, path, root, go, connection }) {
    const [items, setItems] = useState([]);
    const rootRef = useRef(null);
    const [menu, setMenu] = useState([]);
    useEffect(() => {
        setItems(segments(path.substring(root.length)).reduce((all, segment) => [...all, all.length ? join(last(all), segment) : normalize(segment)], []));
    }, [path, root]);
    const names = items.map((name, i) => {
        const path = normalize(root + name);
        return React.createElement(Fragment, { key: i },
            React.createElement("span", { onClick: () => go(path), "data-tooltip": path, onContextMenuCapture: () => setMenu(createMenu(path, connection?.id ?? LocalFileSystemID)) }, basename(name)),
            i < items.length - 1 && React.createElement("i", { className: 'icon' }, "arrow_forward_ios"));
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: rootRef, className: 'breadcrumbs ' + styles.root, onContextMenuCapture: () => setMenu([]) },
            connection ?
                React.createElement("em", { onClick: () => go(root), "data-tooltip": root },
                    React.createElement("i", { className: 'connection icon' }, icon),
                    React.createElement("span", null, connection.name)) :
                React.createElement("i", { className: 'connection icon', onClick: () => go(root), "data-tooltip": root }, icon),
            items.length > 0 && React.createElement("i", { className: 'icon' }, "arrow_forward_ios"),
            names),
        rootRef.current &&
            React.createElement(ContextMenu, { target: rootRef.current }, menu.length > 0
                ? React.createElement(Menu, { items: menu })
                : React.createElement(React.Fragment, null))));
}
